// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`
#include <fog_pars_vertex>

uniform vec2 uFrequency;
uniform float uTime;
uniform float uWind;
uniform float uYOffset;

varying vec2 vUv;
varying float vElevation;
varying float vY;

void main()
{
    #include <begin_vertex>
    #include <project_vertex>
    #include <fog_vertex>
    // #include <fog_vertex>

    float f = uWind;
    // vec4 localPosition = vec4( position, 1.);
     vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    float elevation = sin(modelPosition.x * uFrequency.x  - uTime* f) * 0.1 * (1.0 -uv.y);
    elevation += sin(modelPosition.y * uFrequency.y  - uTime* f * 0.3) * 0.1 * (1.0 - uv.y);

    modelPosition.z += elevation;
    modelPosition.x += elevation;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    vUv = uv;
    vY = modelPosition.y + uYOffset;
    // vElevation = elevation;
    vElevation = 0.0;
}`
